<template>
  <div>
    <div class="loader-div" :class="(PopUp == true ? 'popuploader' : '')">
      <i class="fa-solid fa-spinner fa-spin-pulse"></i>
      <br />
      <br />
      <br />
      <b>{{ LoaderText }} </b>
    </div>
    <div class="popupbg" v-if="PopUp == true"></div>
  </div>
</template>

<script>
export default {
  props: {
    LoaderText: {
      type: String,
      default: "",
    },
    PopUp: {
      typr: Boolean,
      default: false,
    },
  },
};
</script>
<style scoped>
.loader-div {
  position: relative;
  margin: 0px auto !important;
  width: 150px;
  height: 150px;
  border-radius: 15px;
  text-align: center;
  top: 5px;
  background-color: white;
}
.fa-spinner {
  position: relative;
  margin: 0px auto !important;
  top: 25%;
  font-size: 45px;
}

@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}
/* This is the class name given by the Font Awesome component when icon contains 'spinner' */
.fa-spinner {
  /* Apply 'spinner' keyframes looping once every second (1s)  */
  animation: spinner 2s linear infinite;
}

.popuploader {
  position: fixed !important;
  top: 150px !important;
  left: 0;
  right: 0;
  z-index: 10;
}

.popupbg {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vh;
  height: 100vh;
  background-color: #00000047;
  z-index: 9;
}
</style>
